import { JsonObj } from '@mhp/general-interface';

/**
 * Find for objects in the array that have the same matching key
 * and merge them.
 *
 * e.g.
 * mergeArrayObjectsBy([{ a: 1, b: 3 }, { a: 2, b: 4 }, { a: 1, c: 5 }], 'a');
 * // => [{ a: 1, b: 3, c: 5 }, { a: 2, b: 4 }]
 *
 * @param arr the array of objects
 * @param key the key to look for when merging the objects
 * @returns array of objects
 */
export const mergeArrayObjectsBy = (arr: JsonObj[], key: string) => {
  return [
    ...arr
      .reduce(
        (prev: Map<unknown, unknown>, curr: JsonObj) =>
          prev.set(curr[key], Object.assign(prev.get(curr[key]) || {}, curr)),
        new Map()
      )
      .values()
  ];
};
